// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethod from "../Restaumatic.Orders.Types.FulfillmentMethod/index.js";
import * as Restaumatic_Storage from "../Restaumatic.Storage/index.js";
var initialDineInLocationKey = "initialDineInLocation";
var readDineInLocation = function (dictMonadReader) {
    return function (dictMonadEffect) {
        return Restaumatic_Storage.readSessionStoredValue(Restaumatic_Orders_Types_FulfillmentMethod.decodeDineInLocation)(dictMonadReader)(dictMonadEffect)(initialDineInLocationKey);
    };
};
var isDineInOrder = function (dictMonadReader) {
    return function (dictMonadEffect) {
        return Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Data_Maybe.isJust)(readDineInLocation(dictMonadReader)(dictMonadEffect));
    };
};
export {
    readDineInLocation,
    isDineInOrder
};
//# sourceMappingURL=index.js.map
